import { Component } from '@angular/core';
import DisableDevtool from 'disable-devtool';
import { Platform, AlertController } from '@ionic/angular';
import { Location } from '@angular/common';
import { App } from '@capacitor/app';

import FingerprintJS from '@fingerprintjs/fingerprintjs';
import { IdleService } from './core/screen-saver/idle.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {
    isIdle = false;
    showSplash = true;

    /**
     * Constructor
     */
    constructor(
        public platform: Platform,
        private location: Location,
        public alertController: AlertController,
        private idleService: IdleService
    ) {
        this.idleService.onIdle$.subscribe((status) => {
            this.isIdle = status;
        });

        // const fpPromise = FingerprintJS.load({
        //   monitoring: false
        // })
        //   ; (async () => {
        //     // Get the visitor identifier when you need it.
        //     const fp = await fpPromise
        //     const result = await fp.get()
        //     console.log('fingerprint', { 'visitor id': result.visitorId, 'confidence': result.confidence.score })
        //   })()
        if (this.platform.is('android')) {
            this.platform.ready().then(() => {
                this.initializeApp();
                // DisableDevtool({
                //     ondevtoolopen(type, next){
                //         next();
                //     }
                // });}
                 const splashShown = localStorage.getItem('splashShown');
            if (splashShown === 'true') {
                this.showSplash = false; // Skip splash
            } else {
                this.showSplash = true; // Tampilkan splash sekali
            }
            });
        } else if (this.platform.is('ios')) {
            this.platform.ready().then(() => {
                this.initializeApp();
                // DisableDevtool({
                //     ondevtoolopen(type, next){
                //         next();
                //     }
                // });}
                 const splashShown = localStorage.getItem('splashShown');
            if (splashShown === 'true') {
                this.showSplash = false; // Skip splash
            } else {
                this.showSplash = true; // Tampilkan splash sekali
            }
            });
        } else {
            this.platform.ready().then(() => {
                // this.initializeApp()
                // DisableDevtool({
                //     ondevtoolopen(type, next){
                //         next();
                //     }
                // });}
                 const splashShown = localStorage.getItem('splashShown');
            if (splashShown === 'true') {
                this.showSplash = false; // Skip splash
            } else {
                this.showSplash = true; // Tampilkan splash sekali
            }
            });
        }
    }
    initializeApp() {
        App.addListener('backButton', async () => {
            let route = this.location.path();
            if (route.includes('sign-in') || route.includes('home')) {
                await this.showExitConfirm();
            } else {
                this.location.back();
            }
        });
    }
    async showExitConfirm() {
        const alert = await this.alertController.create({
            header: 'App termination',
            message: 'Do you want to close the app?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {},
                },
                {
                    text: 'Exit',
                    handler: () => {
                        App.exitApp();
                    },
                },
            ],
        });
        await alert.present();
    }
    onSplashFinished() {
        console.log('🎬 Splash finished event received');
        this.showSplash = false;
        console.log('showSplash sekarang:', this.showSplash);
         // 🔹 Tandai bahwa splash sudah pernah ditampilkan
        localStorage.setItem('splashShown', 'true');
    }
}
